import { ApiEndpoint } from "@/app/apiEndpoint";
import { formateDate } from "@/app/common/dateFormate";
import { DATE_FORMAT, DATE_TIME_FORMAT } from "@/app/const";
import axios from "@/app/http/axios";
import { ComplaintInfo } from "@/interface/Complaint.interface";
import { MainTopic } from "@/interface/MainTopic.interface";
import {
  OcpbAttachmentInfo,
  OcpbComplaint,
} from "@/interface/OcpbComplaint.interface";
import {
  ComplaintOpmDetail,
  OpmAttachment,
} from "@/interface/OpmComplaint.interface";
import { ReportFilter } from "@/interface/ReportFilter.interface";
import { ComplaintInfoSave } from "@/interface/SaveComplaint.interface";
import { SubTopic } from "@/interface/SubTopic.interface";

export default class ComplaintService {
  constructor() {}

  dateString(date: Date | undefined) {
    if (date) return formateDate(date ?? "", DATE_FORMAT);
    return "";
  }

  dateTimeString(date: Date | undefined) {
    if (date) return formateDate(date ?? "", DATE_TIME_FORMAT);
    return "";
  }

  async getAllComplaintTopics() {
    const path = ApiEndpoint.ComplaintTopic.GET_ALL_MAIN;
    try {
      const response = await axios.get<MainTopic[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getMainById(mainId: string) {
    const path = ApiEndpoint.ComplaintTopic.GET_MAIN_BY_ID;
    try {
      const response = await axios.get<MainTopic>(
        `${path.replace("{id}", mainId)}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllSubTopics(mainId: string) {
    const path = ApiEndpoint.ComplaintTopic.GET_ALL_SUB;
    try {
      const response = await axios.get<SubTopic[]>(
        `${path.replace("{mainId}", mainId)}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getSubById(subId: string) {
    const path = ApiEndpoint.ComplaintTopic.GET_SUB_BY_ID;
    try {
      const response = await axios.get<SubTopic>(
        `${path.replace("{id}", subId)}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllUserRequests() {
    const path = ApiEndpoint.UserComplaint.GET_ALL;
    try {
      const response = await axios.get<ComplaintInfo[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getUserRequestsWithConditions(filter: any) {
    const path = ApiEndpoint.UserComplaint.SEARCH;
    try {
      const response = await axios.post<ComplaintInfo[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getRequestByRequestNo(requestNo: string) {
    const path = ApiEndpoint.UserComplaint.GET_BY_REQNO;
    try {
      const response = await axios.get<ComplaintInfo>(
        `${path.replace("{requestNo}", requestNo)}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createRequest(value: ComplaintInfoSave) {
    const path = ApiEndpoint.UserComplaint.CREATE_REQ;
    try {
      const response = await axios.post<ComplaintInfo>(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateRequest(requestNo: string, value: ComplaintInfoSave) {
    const path = ApiEndpoint.UserComplaint.SAVE_REQ;
    try {
      const response = await axios.patch<ComplaintInfo>(
        `${path.replace("{requestNo}", requestNo)}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async submitRequest(value: any) {
    const path = ApiEndpoint.UserComplaint.SUBMIT_REQ;
    try {
      const response = await axios.post(`${path}`, value);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async cancelRequest(requestNo: string) {
    const path = ApiEndpoint.UserComplaint.CANCEL;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async userEndRequest(requestNo: string, value: any) {
    const path = ApiEndpoint.UserComplaint.END;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async userSendDocs(requestNo: string, value: any) {
    const path = ApiEndpoint.UserComplaint.SAVE_DOC;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async userAppeal(requestNo: string, value: any) {
    const path = ApiEndpoint.UserComplaint.APPEAL;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllRequests() {
    const path = ApiEndpoint.Complaint.GET_ALL;
    try {
      const response = await axios.get<ComplaintInfo[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getRequestsWithConditions(filter: any) {
    const path = ApiEndpoint.Complaint.SEARCH;
    try {
      const response = await axios.post<ComplaintInfo[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async assignDepartment(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.ASSIGN_DPM;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async requestAdditionalDocs(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.REQ_DOC;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async verifyAdditionalDocs(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.CONSIDER_DOC;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async ascSave(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.SUMMARY_SAVE;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async ascEndRequest(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.END;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async summaryRequest(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.SUMMARY;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async summaryToMainResponsible(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.SUMMARY_TO_MAIN;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async sendRequestToAsc(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.SEND_ASC;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async sendRequestToAirline(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.SEND_AIRLINE;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async updateResponsiblePerson(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.UPDATE_PERSON;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async airlineSave(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.AIRLINE_SAVE;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async airlineAnswerToDpm(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.AIRLINE_SUBMIT;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async airlineReturnToDpm(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.AIRLINE_RETURN;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async saveChat(requestNo: string, value: any) {
    const path = ApiEndpoint.Complaint.SAVE_CHAT;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async readChat(requestNo: string) {
    const path = ApiEndpoint.Complaint.READ_CHAT;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async readOpm(requestNo: string) {
    const path = ApiEndpoint.Complaint.READ_OPM;
    try {
      const response = await axios.patch(
        `${path.replace("{requestNo}", requestNo.toString())}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async exportExcel(filter: ReportFilter) {
    let payloads = { ...filter };
    payloads.submittedDate = undefined;
    payloads.submittedDatePicker = undefined;
    payloads.departureDatePicker = undefined;
    const path = ApiEndpoint.Complaint.EXPORT_EXCEL;
    try {
      const response = await axios.post(`${path}`, payloads);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllOcpbRequests(page: number = 1, pageLength: number = 100) {
    const path = ApiEndpoint.OcpbComplaint.GET_ALL;
    const queryParams = new URLSearchParams();

    if (page) queryParams.append("page", page.toString());
    if (pageLength) queryParams.append("pageLength", pageLength.toString());

    try {
      const response = await axios.get<OcpbComplaint[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
        params: queryParams,
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getOcpbRequestsWithConditions(
    filter: any,
    page: number = 1,
    pageLength: number = 100
  ) {
    const path = ApiEndpoint.OcpbComplaint.SEARCH;
    filter.page = page;
    filter.pageLength = pageLength;
    try {
      const response = await axios.post<OcpbComplaint[]>(`${path}`, filter);
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createOcpbRequest(complaintCode: string) {
    const path = ApiEndpoint.OcpbComplaint.CREATE;
    try {
      const response = await axios.post<OcpbComplaint>(`${path}`, {
        complaintCode,
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getOcpbAttachments(complaintCode: string) {
    const path = ApiEndpoint.OcpbComplaint.GET_ATTACH;
    try {
      const response = await axios.post<OcpbAttachmentInfo>(`${path}`, {
        complaintCode,
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async returnToOcpb(requestNo: string, remark: string) {
    const path = ApiEndpoint.OcpbComplaint.RETURN;
    try {
      const response = await axios.patch<ComplaintInfo>(
        `${path.replace("{requestNo}", requestNo)}`,
        {
          reason: remark,
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getOcpbDetail(complaintCode: string) {
    const encodedId = encodeURIComponent(complaintCode);
    const path = ApiEndpoint.OcpbComplaint.GET_DETAIL;
    try {
      const response = await axios.get<OcpbComplaint>(
        `${path.replace("{code}", encodedId)}`,
        {
          headers: { "Content-Type": "application/json" },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async exportPdf(requestNo: string, lang: string = "th") {
    const path = ApiEndpoint.Complaint.EXPORT_PDF;
    try {
      const response = await axios.get<ArrayBuffer>(
        `${path.replace("{requestNo}", requestNo).replace("{lang}", lang)}`,
        {
          responseType: "arraybuffer",
          // headers: { 'Content-Type': 'application/json' },
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async returnToOpm(requestNo: string, remark: string) {
    const path = ApiEndpoint.OpmComplaint.RETURN;
    try {
      const response = await axios.patch<ComplaintInfo>(
        `${path.replace("{requestNo}", requestNo)}`,
        {
          reason: remark,
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getAllOpmRequests(page: number = 1, pageLength: number = 100) {
    const path = ApiEndpoint.OpmComplaint.GET_ALL;
    const queryParams = new URLSearchParams();

    if (page) queryParams.append("page", page.toString());
    if (pageLength) queryParams.append("pageLength", pageLength.toString());

    try {
      const response = await axios.get<ComplaintOpmDetail[]>(`${path}`, {
        headers: { "Content-Type": "application/json" },
        params: queryParams,
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getOpmRequestsWithConditions(
    filter: any,
    page: number = 1,
    pageLength: number = 100
  ) {
    const path = ApiEndpoint.OpmComplaint.SEARCH;
    filter.page = page;
    filter.pageLength = pageLength;
    try {
      const response = await axios.post<ComplaintOpmDetail[]>(
        `${path}`,
        filter
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async createOpmRequest(caseId: string) {
    const path = ApiEndpoint.OpmComplaint.CREATE;
    try {
      const response = await axios.post<ComplaintOpmDetail>(`${path}`, {
        caseId,
      });
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getOpmAttachments(caseId: string) {
    const path = ApiEndpoint.OpmComplaint.GET_ATTACH;
    try {
      const response = await axios.get<OpmAttachment[]>(
        `${path.replace("{caseId}", caseId)}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async downloadAttachment(attachmentId: string) {
    const path = ApiEndpoint.OpmComplaint.DOWNLOAD;
    try {
      const response = await axios.get<any>(
        `${path.replace("{attachmentId}", attachmentId)}`,
        {
          responseType: "blob",
        }
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async getOperatings(caseId: string) {
    const path = ApiEndpoint.OpmComplaint.GET_OPERATING;
    try {
      const response = await axios.get<any>(
        `${path.replace("{caseId}", caseId)}`
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async saveOperating(caseId: string, value: any) {
    const path = ApiEndpoint.OpmComplaint.SAVE_OPERATING;
    try {
      const response = await axios.post<any>(
        `${path.replace("{caseId}", caseId)}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }

  async saveAttachment(caseId: string, value: any) {
    const path = ApiEndpoint.OpmComplaint.SAVE_ATTACH;
    try {
      const response = await axios.post<any>(
        `${path.replace("{caseId}", caseId)}`,
        value
      );
      return response;
    } catch (error: any) {
      throw error;
    }
  }
}
